import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import DynamicTableStateless from './Stateless';

import { reorderRows } from '../internal/helpers';

var DynamicTable = function (_Component) {
  _inherits(DynamicTable, _Component);

  function DynamicTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DynamicTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DynamicTable.__proto__ || _Object$getPrototypeOf(DynamicTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      page: _this.props.defaultPage,
      sortKey: _this.props.defaultSortKey,
      sortOrder: _this.props.defaultSortOrder,
      rows: _this.props.rows
    }, _this.onSetPage = function (page) {
      _this.props.onSetPage(page);
      _this.setState({ page: page });
    }, _this.onSort = function (_ref2) {
      var key = _ref2.key,
          item = _ref2.item,
          sortOrder = _ref2.sortOrder;

      _this.props.onSort({ key: key, item: item, sortOrder: sortOrder });
      _this.setState({ sortKey: key, sortOrder: sortOrder, page: 1 });
    }, _this.onRankEndIfExists = function (params) {
      if (_this.props.onRankEnd) {
        _this.props.onRankEnd(params);
      }
    }, _this.onRankEnd = function (params) {
      var destination = params.destination;
      var _this$state = _this.state,
          rows = _this$state.rows,
          page = _this$state.page;
      var rowsPerPage = _this.props.rowsPerPage;


      if (!destination || !rows) {
        _this.onRankEndIfExists(params);
        return;
      }

      var reordered = reorderRows(params, rows, page, rowsPerPage);

      _this.setState({
        rows: reordered
      });

      _this.onRankEndIfExists(params);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DynamicTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.setState({
        page: newProps.page,
        sortKey: newProps.defaultSortKey,
        sortOrder: newProps.defaultSortOrder,
        rows: newProps.rows
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          page = _state.page,
          sortKey = _state.sortKey,
          sortOrder = _state.sortOrder,
          rows = _state.rows;
      var _props = this.props,
          caption = _props.caption,
          emptyView = _props.emptyView,
          head = _props.head,
          loadingSpinnerSize = _props.loadingSpinnerSize,
          isLoading = _props.isLoading,
          isFixedSize = _props.isFixedSize,
          isRankable = _props.isRankable,
          isRankingDisabled = _props.isRankingDisabled,
          rowsPerPage = _props.rowsPerPage,
          paginationi18n = _props.paginationi18n,
          onRankStart = _props.onRankStart;


      return React.createElement(DynamicTableStateless, {
        paginationi18n: paginationi18n,
        caption: caption,
        emptyView: emptyView,
        head: head,
        loadingSpinnerSize: loadingSpinnerSize,
        isLoading: isLoading,
        isFixedSize: isFixedSize,
        onSetPage: this.onSetPage,
        onSort: this.onSort,
        page: page,
        rows: rows,
        rowsPerPage: rowsPerPage,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRankable: isRankable,
        isRankingDisabled: isRankingDisabled,
        onRankEnd: this.onRankEnd,
        onRankStart: onRankStart
      });
    }
  }]);

  return DynamicTable;
}(Component);

DynamicTable.defaultProps = {
  defaultPage: 1,
  isLoading: false,
  isFixedSize: false,
  isRankable: false,
  onSetPage: function onSetPage() {},
  onSort: function onSort() {},

  rowsPerPage: Infinity
};
export default DynamicTable;